<template>
  <div> 
      <v-container fluid class="grey lighten-5">  
        <h2 style="text-align:center">{{titleGrafico}}</h2>    
        <h2 style="text-align:center">{{titleGrafico2}}</h2>        
        <v-row>          
          <v-col cols="12" lg="12">
            <canvas id="chartPrincipal" ></canvas>
          </v-col>
          <v-col cols="12" lg="12">
            <h4 style="background-color:green; color:white; text-align:center">Superitendência Regional Leste</h4>
          </v-col>
          <v-col cols="12" lg="6">
            <canvas id="chartGraficoLeste" ></canvas>
          </v-col>
          <v-col cols="12" lg="6">
            <canvas id="chartPieLeste" ></canvas>
          </v-col>
          <v-col cols="12" lg="12">
            <h4 style="background-color:green; color:white; text-align:center">Superitendência Regional Oeste</h4>
          </v-col>
          <v-col cols="12" lg="6">
            <canvas id="chartGraficoOeste" ></canvas>
          </v-col>
          <v-col cols="12" lg="6">
            <canvas id="chartPieOeste" ></canvas>
          </v-col>
          <v-col cols="12" lg="12">
            <h4 style="background-color:green; color:white; text-align:center">Superitendência Regional Campos Gerais</h4>
          </v-col>
          <v-col cols="12" lg="6">
            <canvas id="chartGraficoCampos" ></canvas>
          </v-col>
          <v-col cols="12" lg="6">
            <canvas id="chartPieCampos" ></canvas>
          </v-col>
          <v-col cols="12" lg="12">
            <h4 style="background-color:green; color:white; text-align:center">Superitendência Regional Norte</h4>
          </v-col>
          <v-col cols="12" lg="6">
            <canvas id="chartGraficoNorte" ></canvas>
          </v-col>
          <v-col cols="12" lg="6">
            <canvas id="chartPieNorte" ></canvas>
          </v-col>
          <v-col cols="12" lg="12">
            <h4 style="background-color:green; color:white; text-align:center">Superitendência Regional Noroeste</h4>
          </v-col>
          <v-col cols="12" lg="6">
            <canvas id="chartGraficoNoroeste" ></canvas>
          </v-col>
          <v-col cols="12" lg="6">
            <canvas id="chartPieNoroeste" ></canvas>
          </v-col>
        </v-row>
      </v-container>
  </div>
</template>

<script>
import Chart from 'chart.js'
import axios from 'axios'
import * as L from 'leaflet'
//import { condicaoMalhaMapas } from '@/api/vue-exemplo'

export default {
  name: 'CondicaoMalhaMapas',
  data: () => ({
    name: 'der:condicao_malha_grafico_pol_p31982',
    title: 'Condições Malha Gráficos',
    titleGrafico: 'Condição da Malha Rodoviária Pavimentada',
    titleGrafico2: 'do Estado do Paraná 2022',
    //dialog: false,
    //dialog2: false,
    feature: {
      properties: {}
    },
    vetor: [],
    template: [
      //{ text: 'SRE.2015', value: 'sre' },
      { text: 'Regional', value: 'regional' },
      { text: 'Nota 1', value: 'nota_1' },
      { text: 'Nota 2', value: 'nota_2' },
      { text: 'Nota 3', value: 'nota_3' },
      { text: 'Nota 4', value: 'nota_4' },
      { text: 'Nota 5', value: 'nota_5' },
      { text: 'Realizado', value: 'realizado' },
      { text: 'A Realizar', value: 'a_realizar' }
    ]
  }),
    mounted () {
    this.addLayer()
  },


 methods: {
    reset () {
      this.$refs.form.reset()

      //this.removeLayer()

      //this.dialog = false
    },
    addLayer () {
      if (this.geojson) {
        this.$root.$emit('removeGeoJson', this.geojson)
      }

      let params = {
        service: 'wfs',
        version: '2.0.0',
        outputFormat: 'application/json',
        exceptions: 'application/json',
        request: 'GetFeature',
        typeNames: this.name,
        srsName: 'EPSG:4674'
      }

      axios.get(process.env.VUE_APP_GEOSERVER, {
        params: params
      })
        .then(response => {
          this.geojson = L.geoJson(response.data, {
            onEachFeature: (feature) => {    
              
              //let teste = feature.properties[this.template[0].value]
              //let popupContent = '<div><canvas id="chart2" </canvas></div>'
              //popupContent += "<table>"
              for(let header of this.template) {
                  this.vetor.push(feature.properties[header.value])
                //console.log("header " + header.text)
                //console.log("valor " + feature.properties[header.value])
                //if (feature.properties[header.value]=="Leste")
                //popupContent += "<tr><th>" + header.text + ":</th>" +
                //  "<td>" + feature.properties[header.value] + "</td></tr>"
              }

             // popupContent += "</table>"
           //   this.addChart2()
         //     layer.bindPopup(popupContent)
              //var action = () => { 
                //this.dialog2 = true
                this.feature = feature
                setTimeout(() => {
                  this.addChart()
                  this.addChartGraficoLeste()
                  this.addChartPieLeste()
                  this.addChartGraficoOeste()
                  this.addChartPieOeste()
                  this.addChartGraficoCampos()
                  this.addChartPieCampos()
                  this.addChartGraficoNorte()
                  this.addChartPieNorte()
                  this.addChartGraficoNoroeste()
                  this.addChartPieNoroeste()
                  this.removeLayer ()
                }, 300)
              //}
              //layer.on('click', action)
            },
            style: {
              opacity: 0
            }
          })

          //this.$root.$emit('addGeoJson', this.geojson)
        })
        .catch(error => {
          console.log(error)
        })

      //this.dialog = false
    },
    removeLayer () {
      if (this.geojson) {
        this.$root.$emit('removeGeoJson', this.geojson)
       // this.$root.$emit('removeWmsLayer', this.wmsLayer)
      }
    },

    addChart() {
      //console.log("O vetor é " +this.vetor)//eature.properties[this.template[1].value]
      
      if (this.chart) {
        this.chart.data.datasets[0].data = [this.vetor[41], this.vetor[42], this.vetor[43], this.vetor[44], this.vetor[45]]
        this.chart.update()
      } else {
        let ctx = document.getElementById('chartPrincipal').getContext('2d')

        let options = {
          title: {
            display: true,
            text: 'Condição da Malha Total do Estado do Paraná',
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
              }
            }
          },
          legend: {
            display: false
          },
          scales: {
            y: {
              beginAtZero: true
            }
          }
        }

        this.chart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['Péssimo', 'Ruim', 'Regular', 'Bom', 'Muito Bom'],
            datasets: [{
              label: 'Extensão (Km)',
              data: [this.vetor[41], this.vetor[42], this.vetor[43], this.vetor[44], this.vetor[45]],
              backgroundColor: ['rgb(255, 0, 0)','rgb(255, 165, 0)','rgb(255, 255, 0)','rgb(0, 0, 255)', 'rgb(0, 255, 0)']
            }]
          },
          options
        })
      }
    },

    addChartGraficoLeste() {      
      if (this.chartGraficoLeste) {
        this.chartGraficoLeste.data.datasets[0].data = [this.vetor[1], this.vetor[2], this.vetor[3], this.vetor[4], this.vetor[5]]
        this.chartGraficoLeste.update()
      } else {
        let ctx = document.getElementById('chartGraficoLeste').getContext('2d')

        let options = {
          title: {
            display: true,
            text: 'Condição da malha total da regional '  + this.vetor[0]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
              }
            }
          },
          legend: {
            display: false
          },
          scales: {
            y: {
              beginAtZero: true,
              max: 100
            }
          }
        }

        this.chartGraficoLeste = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['Péssimo', 'Ruim', 'Regular', 'Bom', 'Muito Bom'],
            datasets: [{
              label: 'Extensão (Km)',
              data: [this.vetor[1], this.vetor[2], this.vetor[3], this.vetor[4], this.vetor[5]],
              backgroundColor: ['rgb(255, 0, 0)','rgb(255, 165, 0)','rgb(255, 255, 0)','rgb(0, 0, 255)', 'rgb(0, 255, 0)']
            }]
          },
          options
        })
      }
    },

    addChartGraficoOeste() {
      let i = 8;      
      if (this.chartGraficoOeste) {
        this.chartGraficoOeste.data.datasets[0].data = [this.vetor[1+i], this.vetor[2+i], this.vetor[3+i], this.vetor[4+i], this.vetor[5+i]]
        this.chartGraficoOeste.update()
      } else {
        let ctx = document.getElementById('chartGraficoOeste').getContext('2d')

        let options = {
          title: {
            display: true,
            text: 'Condição da malha total da regional '  + this.vetor[0+i]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
              }
            }
          },
          legend: {
            display: false
          },
          scales: {
            y: {
              beginAtZero: true,
              max: 100
            }
          }
        }

        this.chartGraficoOeste = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['Péssimo', 'Ruim', 'Regular', 'Bom', 'Muito Bom'],
            datasets: [{
              label: 'Extensão (Km)',
              data: [this.vetor[1+i], this.vetor[2+i], this.vetor[3+i], this.vetor[4+i], this.vetor[5+i]],
              backgroundColor: ['rgb(255, 0, 0)','rgb(255, 165, 0)','rgb(255, 255, 0)','rgb(0, 0, 255)', 'rgb(0, 255, 0)']
            }]
          },
          options
        })
      }
    },

    addChartGraficoCampos() {
      let i = 16;      
      if (this.chartGraficoCampos) {
        this.chartGraficoCampos.data.datasets[0].data = [this.vetor[1+i], this.vetor[2+i], this.vetor[3+i], this.vetor[4+i], this.vetor[5+i]]
        this.chartGraficoCampos.update()
      } else {
        let ctx = document.getElementById('chartGraficoCampos').getContext('2d')

        let options = {
          title: {
            display: true,
            text: 'Condição da malha total da regional '  + this.vetor[0+i]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
              }
            }
          },
          legend: {
            display: false
          },
          scales: {
            y: {
              beginAtZero: true,
              max: 100
            }
          }
        }

        this.chartGraficoCampos = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['Péssimo', 'Ruim', 'Regular', 'Bom', 'Muito Bom'],
            datasets: [{
              label: 'Extensão (Km)',
              data: [this.vetor[1+i], this.vetor[2+i], this.vetor[3+i], this.vetor[4+i], this.vetor[5+i]],
              backgroundColor: ['rgb(255, 0, 0)','rgb(255, 165, 0)','rgb(255, 255, 0)','rgb(0, 0, 255)', 'rgb(0, 255, 0)']
            }]
          },
          options
        })
      }
    },

    addChartGraficoNorte() {
      let i = 24;      
      if (this.chartGraficoNorte) {
        this.chartGraficoNorte.data.datasets[0].data = [this.vetor[1+i], this.vetor[2+i], this.vetor[3+i], this.vetor[4+i], this.vetor[5+i]]
        this.chartGraficoNorte.update()
      } else {
        let ctx = document.getElementById('chartGraficoNorte').getContext('2d')

        let options = {
          title: {
            display: true,
            text: 'Condição da malha total da regional '  + this.vetor[0+i]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
              }
            }
          },
          legend: {
            display: false
          },
          scales: {
            y: {
              beginAtZero: true,
              max: 100
            }
          }
        }

        this.chartGraficoNorte = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['Péssimo', 'Ruim', 'Regular', 'Bom', 'Muito Bom'],
            datasets: [{
              label: 'Extensão (Km)',
              data: [this.vetor[1+i], this.vetor[2+i], this.vetor[3+i], this.vetor[4+i], this.vetor[5+i]],
              backgroundColor: ['rgb(255, 0, 0)','rgb(255, 165, 0)','rgb(255, 255, 0)','rgb(0, 0, 255)', 'rgb(0, 255, 0)']
            }]
          },
          options
        })
      }
    },

    addChartGraficoNoroeste() {
      let i = 32;      
      if (this.chartGraficoNoroeste) {
        this.chartGraficoNoroeste.data.datasets[0].data = [this.vetor[1+i], this.vetor[2+i], this.vetor[3+i], this.vetor[4+i], this.vetor[5+i]]
        this.chartGraficoNoroeste.update()
      } else {
        let ctx = document.getElementById('chartGraficoNoroeste').getContext('2d')

        let options = {
          title: {
            display: true,
            text: 'Condição da malha total da regional '  + this.vetor[0+i]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
              }
            }
          },
          legend: {
            display: false
          },
          scales: {
            y: {
              beginAtZero: true,
              max: 100
            }
          }
        }

        this.chartGraficoNoroeste = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['Péssimo', 'Ruim', 'Regular', 'Bom', 'Muito Bom'],
            datasets: [{
              label: 'Extensão (Km)',
              data: [this.vetor[1+i], this.vetor[2+i], this.vetor[3+i], this.vetor[4+i], this.vetor[5+i]],
              backgroundColor: ['rgb(255, 0, 0)','rgb(255, 165, 0)','rgb(255, 255, 0)','rgb(0, 0, 255)', 'rgb(0, 255, 0)']
            }]
          },
          options
        })
      }
    },

    addChartPieLeste() {  
      let i = 0;    
      let perc = this.vetor[6+i]
      if (this.chartPieLeste) {
        this.chartPieLeste.data.datasets[0].data = [perc, 100 - perc]
        this.chartPieLeste.update()
      } else {
        let ctx = document.getElementById('chartPieLeste').getContext('2d')

        this.chartPieLeste = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Realizado', 'A realizar'],
            datasets: [{
              label: 'Extensão',
              data: [perc, 100 - perc],
              backgroundColor: ['rgb(0, 128, 0)', 'rgb(255, 40, 0)']
            }]
          },
            options: {
              title: {
                display: true,
                text: "Porcentagem da Malha Realizado Levantamento"
              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem, data) {
                    return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
                  }
                }
              }
          }
        })
      }
    },
    addChartPieOeste() {  
      let i = 8    
      let perc = this.vetor[6+i]
      if (this.chartPieOeste) {
        this.chartPieOeste.data.datasets[0].data = [perc, 100 - perc]
        this.chartPieOeste.update()
      } else {

        let ctx = document.getElementById('chartPieOeste').getContext('2d')

        this.chartPieOeste = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Realizado', 'A realizar'],
            datasets: [{
              label: 'Extensão',
              data: [perc, 100 - perc],
              backgroundColor: ['rgb(0, 128, 0)', 'rgb(255, 40, 0)']
            }]
          },
          options: {              
              title: {
                display: true,
                text: "Porcentagem da Malha Realizado Levantamento"
              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem, data) {
                    return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
                  }
                }
              }
          },
        })
      }
    },
    addChartPieCampos() { 
      let i = 16     
      let perc = this.vetor[6+i]
      if (this.chartPieCampos) {
        this.chartPieCampos.data.datasets[0].data = [perc, 100 - perc]
        this.chartPieCampos.update()
      } else {
        let ctx = document.getElementById('chartPieCampos').getContext('2d')

        this.chartPieCampos = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Realizado', 'A realizar'],
            datasets: [{
              label: 'Extensão',
              data: [perc, 100 - perc],
              backgroundColor: ['rgb(0, 128, 0)', 'rgb(255, 40, 0)']
            }]
          },
            options: {
              title: {
                display: true,
                text: "Porcentagem da Malha Realizado Levantamento"
              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem, data) {
                    return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
                  }
                }
              }
          }
        })
      }
    },
    addChartPieNorte() {      
      let i = 24
      let perc = this.vetor[6+i]
      if (this.chartPieNorte) {
        this.chartPieNorte.data.datasets[0].data = [perc, 100 - perc]
        this.chartPieNorte.update()
      } else {
        let ctx = document.getElementById('chartPieNorte').getContext('2d')

        this.chartPieNorte = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Realizado', 'A realizar'],
            datasets: [{
              label: 'Extensão',
              data: [perc, 100 - perc],
              backgroundColor: ['rgb(0, 128, 0)', 'rgb(255, 40, 0)']
            }]
          },
            options: {
              title: {
                display: true,
                text: "Porcentagem da Malha Realizado Levantamento"
              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem, data) {
                    return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
                  }
                }
              }
          }
        })
      }
    },
    addChartPieNoroeste() { 
      let i = 32     
      let perc = this.vetor[6+i]
      if (this.chartPieNoroeste) {
        this.chartPieNoroeste.data.datasets[0].data = [perc, 100 - perc]
        this.chartPieNoroeste.update()
      } else {
        let ctx = document.getElementById('chartPieNoroeste').getContext('2d')

        this.chartPieNoroeste = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Realizado', 'A realizar'],
            datasets: [{
              label: 'Extensão',
              data: [perc, 100 - perc],
              backgroundColor: ['rgb(0, 128, 0)', 'rgb(255, 40, 0)']
            }]
          },
            options: {
              title: {
                display: true,
                text: "Porcentagem da Malha Realizado Levantamento"
              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem, data) {
                    return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
                  }
                }
              }
          }
        })
      }
    },
    /*
        addChartPie2(regional, i, idName) {      
      var perc = this.vetor[6+i]
      if (this.chartPie) {
        this.chartPie.data.datasets[0].data = [perc, 100 - perc]
        this.chartPie.update()
      } else {
        var ctx = document.getElementById(idName).getContext('2d')

        this.chartPie = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Realizado', 'A realizar'],
            datasets: [{
              label: 'Extensão',
              data: [perc, 100 - perc],
              backgroundColor: ['rgb(0, 128, 0)', 'rgb(255, 40, 0)']
            }]
          },
            options: {
              title: {
                display: true,
                text: "Superitendência Regional " + regional
              }
          }
        })
      }
    },
    */
    addChart4() {
      let perc = this.feature.properties['nota_3']
      if (this.chart2) {
        this.chart2.data.datasets[0].data = [perc, 100 - perc]
        this.chart2.update()
      } else {
        let ctx = document.getElementById('chart4').getContext('2d')

        this.chart2 = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Realizado', 'A realizar'],
            datasets: [{
              label: 'Extensão',
              data: [perc, 100 - perc],
              backgroundColor: ['rgb(0, 0, 255)', 'rgb(211, 211, 211)']
            }]
          }
        })
      }
    },
    addChart5() {
      let perc = this.feature.properties['nota_4']
      if (this.chart2) {
        this.chart2.data.datasets[0].data = [perc, 100 - perc]
        this.chart2.update()
      } else {
        let ctx = document.getElementById('chart5').getContext('2d')

        this.chart2 = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Realizado', 'A realizar'],
            datasets: [{
              label: 'Extensão',
              data: [perc, 100 - perc],
              backgroundColor: ['rgb(255, 255, 0)', 'rgb(211, 211, 211)']
            }]
          }
        })
      }
    }
  }
}
</script>
